import { APIClient } from '@frontend/api-utils';

export class SlotEnumClient extends APIClient {
    public static readonly endpoint = '/slot-api/v1';

    public static async fetchSlotStates(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/slot-states`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchSlotTriggers(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/slot-triggers`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchSlotActions(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/slot-actions`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchConstraintTypes(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/constraint-types`);
        return await this.handleResponse<string[]>(response);
    }

    public static async fetchConstraintModes(): Promise<string[]> {
        const response = await this.fetch(`${this.endpoint}/constraint-modes`);
        return await this.handleResponse<string[]>(response);
    }
}
